export const doesScriptExistInDom = (href) => {
  return document.querySelectorAll(`script[src^="${href}"]`).length > 0;
}

export const formatPhoneNumber = (phoneNumber, countryCode) => {
  let formattedPhoneNumber = phoneNumber.replace(/\D/g, '');
  if (!formattedPhoneNumber.startsWith(countryCode)) {
    formattedPhoneNumber = countryCode + formattedPhoneNumber;
  }
  return formattedPhoneNumber;
}

export const getInputValueById = (id) => {
  try {
    return document.getElementById(id).value;
  } catch (e) {
    return null;
  }
}